import { injectIntl } from "react-intl";
import moment from "moment";
import momentLocalizer from "react-widgets-moment";
import DateTimePicker from "react-widgets/lib/DateTimePicker";
import InputGroup from "./InputGroup";
import { handleFormikValueChange, locale } from "../../utils";
import { intlShape } from "../../shapes";

type OwnProps = {
  disabled?: boolean;
  useLocaleSetting?: boolean;
  name?: string;
  placeholder?: string;
  minDate?: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
  defaultValue?: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
  input?: $TSFixMe; // TODO: PropTypes.instanceOf(Object)
  values?: $TSFixMe; // TODO: PropTypes.instanceOf(Object)
  intl?: intlShape;
  handleBlur?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  disabled: false,
  useLocaleSetting: false,
  defaultValue: undefined,
};

type Props = OwnProps & typeof defaultProps;

function DateInput(props: Props) {
  const {
    defaultValue,
    minDate,
    values,
    name,
    disabled,
    handleBlur,
    placeholder,
  } = props;

  moment.locale(locale());
  // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
  momentLocalizer(moment);

  const dateTimePicker = (
    <DateTimePicker
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ className: string; name: string | undefine... Remove this comment to see the full error message
      className="date-time-input"
      name={name}
      disable={disabled}
      time={false}
      defaultValue={defaultValue}
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      value={values && values[name]}
      onChange={(value) => handleFormikValueChange(props, value)}
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onBlur={(e) => handleBlur(e)}
      min={minDate}
      placeholder={placeholder}
    />
  );

  return <InputGroup {...props}>{dateTimePicker}</InputGroup>;
}

DateInput.defaultProps = defaultProps;

export default injectIntl(DateInput);
